import CircularProgress from '@mui/material/CircularProgress';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useTranslation } from 'next-i18next';
import React, { useEffect, useState } from 'react';
import type { PresentationMeetingAnalytics } from '../../../../interfaces/interfaces';
import { numberWithThousandPoint } from '../../../../services/helper';
import { infosPresentationMeeting } from '../../../../services/services';
import VyButton from '../../../common/VyButton';
import VyModal from '../../../common/VyModal';
import VyNoData from '../../../common/VyNoData';

interface PresentationInfosProps {
  onCloseModal: () => void;
  presentationId: string;
}

export const PresentationInfos = (props: PresentationInfosProps) => {
  const { t } = useTranslation('account');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [infos, setInfos] = useState<PresentationMeetingAnalytics[]>([]);

  async function presentationMeetingRoomUsers(meetingroomid: string) {
    setIsLoading(true);
    try {
      const selected = await infosPresentationMeeting(meetingroomid);
      setInfos(selected.data);
    } catch (err) {
      console.error(err);
    }
    setIsLoading(false);
  }

  useEffect(() => {
    presentationMeetingRoomUsers(props.presentationId);
  }, [props.presentationId]);

  const totalDurations = infos?.reduce(function (total, info) {
    return total + Math.floor(info?.duration / 60000);
  }, 0);
  return (
    <>
      <VyModal maxWidth="90vw" open onClose={props.onCloseModal}>
        {(onClose) => (
          <>
            <div className="p-4 flex flex-col block">
              {isLoading && (
                <div className="text-center m-4">
                  <CircularProgress />
                </div>
              )}
              {!isLoading && infos.length !== 0 && (
                <div>
                  <p className="text-center text-xl font-semibold	mb-2">
                    {t('infos-title')}: {numberWithThousandPoint(infos.length)}
                    <br />
                    {t('total-participation-duration', { total: numberWithThousandPoint(totalDurations) })}
                  </p>
                  <TableContainer component={Paper} className="mb-4">
                    <Table className="min-w-full" aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell align="center"> {t('infos-users')}</TableCell>
                          <TableCell align="center"> {t('infos-duration')}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {infos.map((info) => (
                          <TableRow key={info?.user?._id}>
                            <TableCell align="left">{info?.user?.name}</TableCell>
                            <TableCell align="center">
                              {
                                // if the floor is 0 but the duration is returned the user has spent less then a minute in the presentation.
                                // for better readability we display this as a <1 instead of a 0
                                Math.floor(info?.duration / 60000) > 0 ? numberWithThousandPoint(Math.floor(info?.duration / 60000)) : '<1'
                              }
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              )}
            </div>
            {!isLoading && infos.length === 0 && <VyNoData noDataText={t('infos-no-data')} />}

            <div className="text-center">
              <VyButton onClick={() => onClose?.()} className="m-1">
                {t('infos-button')}
              </VyButton>
            </div>
          </>
        )}
      </VyModal>
    </>
  );
};
